// Copyright (c) 2023 Siemens

/**
 * @module js/DragDropService
 */

export const listDragStart = (extraParams, dnDParams) => {
    // array of objects
    dnDParams.event.dataTransfer.setData('text/plain', JSON.stringify( dnDParams.targetObjects ));
};

